import React, { useState, useEffect, useRef } from 'react';
import { optimizeSbImage } from '../utils/image';
import { storyblokEditable } from '@storyblok/react';
import { render } from 'storyblok-rich-text-react-renderer';

const Project = ({ blok }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const projectRef = useRef(null);

  const toggleExpand = () => setIsExpanded(!isExpanded);

  // Fix links to open in new tab after rendering
  useEffect(() => {
    if (projectRef.current) {
      const links = projectRef.current.querySelectorAll('a');
      links.forEach(link => {
        link.setAttribute('target', '_blank');
        link.setAttribute('rel', 'noopener noreferrer');
      });
    }
  }, [blok._uid]);

  return (
    <div 
      ref={projectRef}
      {...storyblokEditable(blok)} 
      className={`project ${isExpanded ? 'expanded' : ''}`} 
      onClick={toggleExpand}
    >
      <h2>{blok.title}</h2>
      <p className="short-description">{blok.short_description}</p>
      <div className="content">
        <div className="long-description">
          {render(blok.description)}
        </div>
        <div className="asset-gallery">
          {blok.assets.map((asset) => (
            <img
              key={asset.id}
              src={optimizeSbImage(asset.filename, { quality: 70, width: 800 })}
              alt={asset.alt || ''}
              loading="lazy"
              decoding="async"
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Project;
